// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-icon[data-v-44c2130c]{width:30px;height:30px;border-radius:100%;border:1px solid #ccc;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;-ms-flex-negative:0;flex-shrink:0}.profile-icon span[data-v-44c2130c]{size:12px;height:18px;color:#212529;font-weight:500}", ""]);
// Exports
module.exports = exports;
